var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegistered(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,24A12,12,0,0,1,3.514,3.514,12,12,0,0,1,20.486,20.486,11.922,11.922,0,0,1,12,24ZM12,1.688A10.313,10.313,0,1,0,22.313,12,10.324,10.324,0,0,0,12,1.688Zm5.039,17.2H15.126L10.561,12.71h-.532v6.179H8.508V5.343h2.653a14.514,14.514,0,0,1,2.92.2,3.567,3.567,0,0,1,1.382.658,3.217,3.217,0,0,1,.919,1.193,3.849,3.849,0,0,1,.338,1.619,3.494,3.494,0,0,1-1.1,2.694,4.548,4.548,0,0,1-3.168,1.007l4.583,6.18ZM10.031,6.9v4.254H12.2a3.948,3.948,0,0,0,2.2-.488,1.843,1.843,0,0,0,.743-1.629,1.858,1.858,0,0,0-.725-1.629A4,4,0,0,0,12.155,6.9Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistered);
export default __webpack_public_path__ + "static/media/registered.a7ccb62d.svg";
export { ForwardRef as ReactComponent };